import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let FutureContractApiPromise: Promise<AxiosInstance> | null = null;

const getFutureContractApi = async (): Promise<AxiosInstance | null> => {
  if (FutureContractApiPromise) return FutureContractApiPromise;
  FutureContractApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return FutureContractApiPromise;
};

export interface GetFutureContractsProps {
  fecha?: string;
  monto?: number;
  estados?: number[];
  nroCuenta?: string;
  toneladas?: number;
  grano?: number;
  "P.Pagina"?: number;
  "P.Records"?: number;
}

export const getFutureContracts = async (props?: GetFutureContractsProps) => {
  const api = await getFutureContractApi();
  if (!api) return;

  const response = await api.get(
    `/ContratoFuturo/GetListadoContratoFuturo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetFutureContractProps {
  id: number;
}

export const getFutureContract = async (props: GetFutureContractProps) => {
  const api = await getFutureContractApi();
  if (!api) return;

  const response = await api.get(
    `/ContratoFuturo/GetDetalleContratoFuturo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateFutureContractProps {
  nroCuentaOrigen: string;
  tipoFijacion: string;
  grano: number;
  cosecha: string;
  toneladas: number;
  monto: number;
  esCanje: boolean;
  mensaje: string;
  tipoMoneda: string
  entrega: string
}

export const createFutureContract = async (props: CreateFutureContractProps) => {
  const api = await getFutureContractApi();
  if (!api) return;

  const response = await api.post(
    `/ContratoFuturo/CrearContratoFuturo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateFutureContractProps {
  idSolicitud: number;
  mensaje?: string;
  monto?: number;
  toneladas?: number
  entrega?: string
  estado?: number
  precioFinal?: number
}

export const updateFutureContract = async (props: UpdateFutureContractProps) => {
      const api = await getFutureContractApi();
  if (!api) return;

  const response = await api.put(
    `/ContratoFuturo/EditarContratoFuturo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
}